<template>
  <span
    class="loader"
    :style="loaderStyle"
  />
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  width: {
    type: String,
    default: "44px",
  },
  height: {
    type: String,
    default: "44px",
  },
  color: {
    type: String,
    default: "#FFFFFF",
  },
});

const loaderStyle = computed(() => ({
  width: props.width,
  height: props.height,
  "--loader-border-color": props.color,
}));
</script>

<style lang="scss" scoped>


.loader {
  display: block;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  /* margin: 18% 0 0 50%; */
  position: relative;
}
.loader::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid var(--loader-border-color, #FFFFFF);
  animation: prixClipFix 2s linear infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }
  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}
</style>
